/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/operator-cta';
import { getAltText, imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import ReviewLink from 'gatsby-core-theme/src/components/atoms/review-link';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus-box/template-one';
import LazyImage from '~hooks/lazy-image';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import { TrackingKeys } from '~constants/tracking-api'

import styles from './popup-card.module.scss';

const PopupCard = ({
  item,
  tracker,
  showName = false,
  showRating = false,
  showReviewLink = false,
  buttonSize = '',
  buttonType = 'primary',
  template,
  itemPosition
}) => {
  const operatorName = item.name;
  const oneLiner = item?.one_liners?.main?.one_liner;
  const imageObject = item?.logo;

  return (
    <div className={styles?.popupCard || ''}>
      <div className={styles?.imgContainer || ''}>
        <LazyImage
          src={imagePrettyUrl(imageObject?.filename, 98, 98)}
          alt={getAltText(imageObject, oneLiner)}
          width={98}
          height={98}
        />
        {showRating && <StarRating numOfStars={5} rating={item?.rating} />}
        {showName && <p className={styles?.name || ''}>{operatorName}</p>}
      </div>
      <Bonus item={item} tracker={tracker} pageTemplate={template}  moduleName={TrackingKeys?.POPUP} itemPosition={itemPosition} />
      <div className={styles?.buttonContainer || ''}>
        <OperatorCta
          tracker={tracker}
          moduleName={TrackingKeys?.POPUP}
          operator={item}
          buttonSize={buttonSize}
          buttonType={buttonType}
          translationsObj={{
            active: { translationKey: 'play_now_popup', defaultValue: 'Play Now' },
            not_recommended: { translationKey: 'not_recommended', defaultValue: 'Not Recommended' },
            coming_soon: { translationKey: 'coming_soon', defaultValue: 'Soon Available' },
            inactive: { translationKey: 'inactive', defaultValue: 'Not Accepting New Players' },
            blacklisted: { translationKey: 'blacklisted', defaultValue: 'Blacklisted' },
          }}
          gtmClass="popup-operator-cta-gtm"
          pageTemplate={template}
          itemPosition={itemPosition}
        />
        {showReviewLink && (
          <ReviewLink
            className={`${styles.reviewLink} popup-review-gtm`}
            template={template}
            operatorName={item.name}
            reviewPath={item.review_link}
          />
        )}
      </div>
      <Tnc operator={item} isFixed />
    </div>
  );
};

PopupCard.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    bonus: PropTypes.shape({
      operator_name: PropTypes.string,
    }),
    links: PropTypes.shape({
      main: PropTypes.string,
    }),
    logo: PropTypes.shape({
      alt: PropTypes.string,
    }),
    review_link: PropTypes.string,
    rating: PropTypes.string,
    logo: PropTypes.shape({
      alt: PropTypes.string,
    }),
    extra_fields: PropTypes.shape({
      terms_and_conditions_text_enabled: PropTypes.string,
    }),
    one_liners: PropTypes.shape({
      main: PropTypes.shape({
        one_liner: PropTypes.string,
      }),
      secondary: PropTypes.shape({
        one_liner: PropTypes.string,
      }),
    }),
  }),
  tracker: PropTypes.string,
  showName: PropTypes.bool,
  showTnc: PropTypes.bool,
  showRating: PropTypes.bool,
  showReviewLink: PropTypes.bool,
  template: PropTypes.string,
  hasCollapse: PropTypes.bool,
  buttonSize: PropTypes.string,
  buttonType: PropTypes.string,
};

export default PopupCard;
